export default "__VITE_ASSET__DpFnmcZu__"